import React, { useEffect } from "react";

const Modal = ({ isOpen, onClose, children, modalClass, bgStyle }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
      document.body.style.touchAction = "none";
    } else {
      document.body.style.overflow = "";
      document.body.style.touchAction = "";
    }

    return () => {
      document.body.style.overflow = "";
      document.body.style.touchAction = "";
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="fixed top-0 left-0 w-full h-full flex p-4 px-6 items-center justify-center z-50">
      <div
        className={`fixed top-0 left-0 w-full h-full bg-[#0000006E] ${bgStyle || ''}`}
      // onClick={onClose}
      ></div>

      <div
        className={`fixed xl:w-[37%] lg:w-[48%] md:w-[60%] sm:w-[80%] w-[90%] bg-white rounded-3xl p-4 max-h-[96%] custom-scrollbar flex flex-col gap-4 overflow-auto justify-between ${modalClass || ''}`}
      >
        <div className="w-full">{children}</div>
      </div>
    </div>
  );
};

export default Modal;
